<div class="sections">
  <div class="card header-card">
    <div class="card-header display-flex billing-header">
      <div class="flex-start gap-3">
        <button class="btn btn-light" (click)="goBack()">
          <i class="fa fa-angle-left"></i>
          Back
        </button>
        <h5 class="mb-0">Pillar name - {{ selectedPillar || "-" }}</h5>
      </div>
    </div>
  </div>

  <div class="card">
    <div class="card-body flow-auto">
      <div class="alert alert-danger" *ngIf="errorMessage">
        {{ errorMessage }}
      </div>

      <table class="table table-docs table-hover">
        <thead>
          <tr>
            <th>S.No</th>
            <th>Problem</th>
            <th>Impact</th>
            <th>Solution</th>
            <th>Impacted Field</th>
            <th>Impacted Value</th>
          </tr>
        </thead>
        <tbody *ngIf="rows.length > 0">
          <tr *ngFor="let row of rows; let i = index">
            <td>{{ i + 1 }}</td>
            <td class="wrap-col">{{ row.problem }}</td>
            <td>{{ row.impact }}</td>
            <td class="wrap-col">{{ row.solution }}</td>
            <td>{{ row.impacted_field }}</td>
            <td>{{ row.impacted_value }}</td>
            <td>
              <button
                type="button"
                class="info-button"
                (click)="openInfoModal(row.details)"
                title="More information"
              >
                <i
                  class="fa fa-info-circle info-icon"
                  aria-hidden="true"
                ></i>
              </button>
            </td>
          </tr>
        </tbody>
        <tbody *ngIf="!loading && rows.length === 0">
          <tr>
            <td colspan="7" class="center">No recommendations found</td>
          </tr>
        </tbody>
        <tbody *ngIf="loading">
          <tr>
            <td colspan="7" class="center">
              <div class="loader-wrap">
                <img src="assets/img/loading_2.svg" alt="loading scans" class="width-18" />
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

<div class="info-modal-backdrop" *ngIf="showInfoModal" (click)="closeInfoModal()">
  <div class="info-modal" (click)="$event.stopPropagation()">
    <div class="info-modal-header">
      <h6 class="mb-0">Recommendation Details</h6>
      <button type="button" class="close-btn" (click)="closeInfoModal()">
        <i class="fa fa-times" aria-hidden="true"></i>
      </button>
    </div>
    <div class="info-modal-body">
      <table class="info-table" *ngIf="selectedInfoRows.length > 0">

        <tbody>
          <tr *ngFor="let item of selectedInfoRows">
            <td class="info-key">{{ item.field }}</td>
            <td class="info-value">{{ item.value }}</td>
          </tr>
        </tbody>
      </table>
      <div class="center" *ngIf="selectedInfoRows.length === 0">No details available</div>
    </div>
  </div>
</div>
